import { inject, Injectable } from "@angular/core";
import { InitTask } from "./init-task.interface";
import { CatalogStore } from "../shared/store/catalog/catalog.store";

/** Файл, в котором мы подключаем сервис/стор обязательный для загрузки перед очисткой splash screen */

@Injectable({ providedIn: 'root' })
export class DataInitTask implements InitTask {
    private catalogStore = inject(CatalogStore);

    description = 'init.catalog';
    priority = 2;
    async run() {
        await this.catalogStore.ensureFoldersLoaded();
    }
}
